import React from 'react';
import { theme } from '../../design/theme';
import { useNavigate } from 'react-router-dom';

export const ActivateEnterprisePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.colors.background.muted,
      padding: theme.spacing.lg
    }}>
      <div style={{
        width: '100%',
        maxWidth: '500px',
        backgroundColor: theme.colors.background.surface,
        padding: theme.spacing.xl,
        borderRadius: '12px',
        boxShadow: theme.shadows.lg,
        border: `1px solid ${theme.colors.neutral[200]}`,
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '64px', marginBottom: theme.spacing.md }}>⏳</div>
        <h2 style={{ ...theme.typography.h2, marginBottom: theme.spacing.md }}>
          Subscription Required
        </h2>
        <p style={{ ...theme.typography.body, color: theme.colors.neutral[500], marginBottom: theme.spacing.xl }}>
          The enterprise features are not yet activated for your account. Please contact support to activate your subscription.
        </p>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: theme.spacing.md,
            backgroundColor: theme.colors.brand.main,
            color: '#FFFFFF',
            border: 'none',
            borderRadius: '6px',
            fontWeight: '600',
            cursor: 'pointer',
            width: '100%'
          }}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};
